'use client';

import { usePathname } from 'next/navigation';
import { TranslationProvider } from '@/lib/i18n/TranslationProvider';
import type { Locale } from '@/lib/i18n';
import { ReactNode } from 'react';

export default function GlobalTranslationWrapper({ children }: { children: ReactNode }) {
    const pathname = usePathname();
    
    // Detect locale from pathname (e.g., /es/... -> es)
    const getLocale = (): Locale => {
        const segments = pathname.split('/');
        const firstSegment = segments[1];
        if (firstSegment === 'pt' || firstSegment === 'es' || firstSegment === 'hi') {
            return firstSegment as Locale;
        }
        return 'en';
    };

    return (
        <TranslationProvider locale={getLocale()}>
            {children}
        </TranslationProvider>
    );
}
